import React from 'react';
import { Link } from 'react-router-dom';
import { extractNumericId } from '../../utils/formatters';
import Card from '../Card';
import Button from '../Button';
import './styles.css';

/**
 * 客戶信息卡片組件
 * 用於顯示客戶基本信息
 * 
 * @param {Object} props - 組件屬性
 * @param {Object} props.customer - 客戶數據
 * @param {boolean} props.showActions - 是否顯示操作按鈕
 * @param {boolean} props.showDetails - 是否顯示詳細信息
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 客戶信息卡片組件
 */
function CustomerCard({ customer, showActions = true, showDetails = true, className = '' }) {
    if (!customer) return null;

    return (
        <Card className={`customer-card ${className}`}>
            <div className="customer-card-header">
                <h3 className="customer-card-name">
                    {customer.firstName} {customer.lastName}
                </h3>
                <div className="customer-card-id">
                    ID: {extractNumericId(customer.id)}
                </div>
            </div>
            <div className="customer-card-content">
                <p><strong>電子郵件:</strong> {customer.email || '未設置'}</p>
                <p><strong>NFC ID:</strong> {customer.nfc_id || '未設置'}</p>
                <p><strong>客戶等級:</strong> {customer.level || '普通'}</p>

                {showDetails && (
                    <>
                        <p><strong>電話:</strong> {customer.phone || '未設置'}</p>
                        {customer.gender && (
                            <p><strong>性別:</strong> {
                                customer.gender === 'male' ? '男性' :
                                    customer.gender === 'female' ? '女性' :
                                        customer.gender === 'other' ? '其他' :
                                            customer.gender
                            }</p>
                        )}
                        {customer.address && (
                            <p><strong>地址:</strong> {customer.address}</p>
                        )}
                        {customer.city && (
                            <p><strong>城市:</strong> {customer.city}</p>
                        )}
                        {customer.country && (
                            <p><strong>國家:</strong> {customer.country}</p>
                        )}
                        {customer.postalCode && (
                            <p><strong>郵編:</strong> {customer.postalCode}</p>
                        )}
                        {customer.notes && (
                            <div className="customer-card-notes">
                                <strong>備註:</strong>
                                <p>{customer.notes}</p>
                            </div>
                        )}
                    </>
                )}
            </div>

            {showActions && (
                <div className="customer-card-actions">
                    <Link to={`/customers/${extractNumericId(customer.id)}`}>
                        <Button variant="secondary" size="small">
                            查看
                        </Button>
                    </Link>
                    <Link to={`/customers/${extractNumericId(customer.id)}/edit`}>
                        <Button variant="secondary" size="small">
                            編輯
                        </Button>
                    </Link>
                    {/* <Link to={`/customers/${extractNumericId(customer.id)}/warranties`}>
                        <Button variant="primary" size="small">
                            保修單
                        </Button>
                    </Link> */}
                </div>
            )}
        </Card>
    );
}

export default CustomerCard; 